const ArrayMixin = {
  methods: {
    isArrayValueEquals(array1, array2) {
      // if the other array is a falsy value, return
      if (array1 === array2) {
        return true
      }

      if (!array1 || !array2) {
        return false
      }

      // compare lengths - can save a lot of time
      if (array1.length !== array2.length) {
        return false
      }

      return array1.every(function(item) {
        return array2.includes(item)
      })
    },
    removeArrayObject(array, item, keyProp) {
      let index = array.findIndex(elem => elem[keyProp] === item[keyProp])
      if (index >= 0) {
        array.splice(index, 1)
      }
      return array
    }
  }
}

export { ArrayMixin as default }
